"use client";

import { Search } from "lucide-react";
import { useRouter } from "next/navigation";
import { FormEvent, useState } from "react";

export default function BlogSearchForm({ defaultValue }: { defaultValue: string }) {
  const router = useRouter();
  const [q, setQ] = useState(defaultValue);

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = q.trim();
    router.push(trimmed ? `/blog?q=${encodeURIComponent(trimmed)}` : "/blog");
  };

  return (
    <form onSubmit={onSubmit} className="relative">
      <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Szukaj artykułów..."
        className="w-full pl-12 pr-28 py-3.5 rounded-full bg-white text-slate-900 placeholder:text-slate-400 outline-none ring-2 ring-transparent focus:ring-yellow-300 shadow-md"
      />
      <button
        type="submit"
        className="absolute right-1.5 top-1/2 -translate-y-1/2 px-5 h-11 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-colors"
      >
        Szukaj
      </button>
    </form>
  );
}
